import React, { Fragment } from 'react';

import { ALBUM_SUBTYPE, ALBUM_TYPE } from '../../../../constants/albums';
import useDismissiblePersistent from '../../../../hooks/useDismissiblePersistent';
import ContributorActionsModal from '../../../pro/views/AutoContributorLinkHandler/components/ContributorActionsModal/ContributorActionsModal';
import { isAlbum } from '../../../../util/album';

export const shouldShowCTA = ({
  isShutterbugEntity,
  isUserOnboarded,
  isUserEntityCreator,
  hasUserDismissedCTAModal,
}) => {
  return (
    isShutterbugEntity &&
    !isUserOnboarded &&
    !isUserEntityCreator &&
    !hasUserDismissedCTAModal
  );
};

const withCTAProps = WrappedComponent => props => {
  const { album, authenticated, albumFolder, user } = props;
  const entity = album || albumFolder;

  if (!album && !albumFolder) {
    // In some kind of loading state.
    return <WrappedComponent {...props} />;
  }

  /*
   * Determine if we will show the modal.
   * We shall only display it once per gallery join. In the odd case
   * (if ever, really) the root is not identified fall back to entity id
   */
  const { visible, onDismiss } = useDismissiblePersistent(
    `HAS_DISMISSED_ONBOARDING_MODAL_FOR_${
      (isAlbum(entity) ? entity.root_album_folder?.id : entity.root?.id) ??
      entity.id
    }`,
  );

  const account = entity.account ?? entity.creator;

  // If user is logged in, check their ID against the respective creator.
  const isUserEntityCreator = authenticated && user && account?.id === user?.id;

  const isUserOnboarded =
    entity.account_has_onboarded ||
    entity.root_album_folder?.account_has_onboarded;

  const shouldShowShutterbugOnboardingCTAModal = (() => {
    if (!visible) {
      return false;
    }

    if (
      entity.album_type !== ALBUM_TYPE.SHUTTERBUG &&
      entity.album_type !== ALBUM_TYPE.PRO
    ) {
      return false;
    }

    if (isUserEntityCreator || isUserOnboarded) {
      return false;
    }

    if (
      [ALBUM_SUBTYPE.SCHOOLS, ALBUM_SUBTYPE.CAMPS].includes(
        albumFolder?.album_subtype,
      )
    ) {
      return false;
    }

    return true;
  })();

  return (
    <Fragment>
      <WrappedComponent
        {...props}
        showCTASubscribeButton={!isUserOnboarded && !isUserEntityCreator}
      />
      <ContributorActionsModal
        forceOpen={shouldShowShutterbugOnboardingCTAModal}
        actionProps={{
          entity,
        }}
        onViewPhotos={() => {
          onDismiss();
        }}
      />
    </Fragment>
  );
};

export default withCTAProps;
